import { Crown, RefreshCw, Timer } from "lucide-react";
import { useCallback, useEffect, useState } from "react";
import { Link } from "react-router-dom";

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;
const RACE_TYPES = [
  { key: "corporate", title: "Fastest Corporate" },
  { key: "rebel", title: "Fastest Rebel" },
  { key: "blackout", title: "Fastest Blackout" },
];

const formatElapsed = (seconds) => {
  const mins = Math.floor(seconds / 60);
  const secs = seconds % 60;
  return mins ? `${mins}M ${String(secs).padStart(2, "0")}S` : `${secs}S`;
};

export function BingoRaceBoard({ refreshKey = 0, signedIn = false }) {
  const [race, setRace] = useState({ week: "", week_ends_at: "", corporate: [], rebel: [], blackout: [] });
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState("");

  const load = useCallback(async () => {
    setLoading(true);
    setError("");
    try {
      const response = await fetch(`${API}/dolopals/bingo/race`, { cache: "no-store" });
      if (!response.ok) throw new Error("Race unavailable");
      setRace(await response.json());
    } catch {
      setError("WEEKLY RACE SIGNAL LOST — RETRY TRANSMISSION.");
    } finally {
      setLoading(false);
    }
  }, []);

  useEffect(() => {
    load();
  }, [load, refreshKey]);

  return (
    <section className="bingo-race-board" data-testid="bingo-race-board">
      <div className="bingo-race-head">
        <div>
          <span>WEEKLY BINGO RACE</span>
          <h3>Fastest survivors take the crown.</h3>
          <p data-testid="bingo-race-week">
            ACTIVE WEEK {race.week || "—"} · RESETS MONDAY 00:00 UTC
          </p>
        </div>
        <button type="button" onClick={load} disabled={loading} data-testid="bingo-race-refresh-button">
          <RefreshCw size={13} className={loading ? "is-spinning" : ""} /> {loading ? "SYNCING" : "REFRESH"}
        </button>
      </div>
      {!signedIn ? (
        <p className="bingo-race-signin" data-testid="bingo-race-signin">
          <Timer size={13} /> Sign in to enter this week’s race. <Link to="/account">LINK ACCOUNT</Link>
        </p>
      ) : null}
      {error ? <p className="bingo-leaderboard-error" data-testid="bingo-race-error">{error}</p> : null}
      <div className="bingo-race-grid">
        {RACE_TYPES.map(({ key, title }) => (
          <article className={`bingo-race-card race-${key}`} key={key} data-testid={`bingo-race-${key}`}>
            <h4><Crown size={15} /> {title}</h4>
            {race[key]?.length ? (
              <ol>
                {race[key].slice(0, 3).map((entry, index) => (
                  <li key={`${entry.tag}-${entry.achieved_at || index}`} data-testid={`bingo-race-row-${key}-${index}`}>
                    <span className="race-rank">{index === 0 ? <Crown size={13} /> : String(index + 1).padStart(2, "0")}</span>
                    <div>
                      <strong>{entry.name}</strong>
                      <small>{entry.tag} · {entry.score} PTS</small>
                    </div>
                    <b>{formatElapsed(entry.elapsed_seconds)}</b>
                  </li>
                ))}
              </ol>
            ) : (
              <p className="leaderboard-empty">NO FINISH RECORDED THIS WEEK.</p>
            )}
          </article>
        ))}
      </div>
    </section>
  );
}
